import { BreadCrumbItemProps, useTranslations } from "@mzara/component";

export const useBreadCrumbItems = (): Array<BreadCrumbItemProps> => {
    const [HOME, FORMATION] = useTranslations(i18n);

    return [{ label: HOME }, { label: FORMATION }];
};

const i18n = ["std_home", "std_formation"];
